import "./chat.css";

const Chat = () => {
    return (
        <>
            <h4>Chat</h4>
        </>
    )
}

export default Chat;